<template>

  <!-- Student's Name at the Top Center -->
  <h1 class="text-3xl font-bold mb-6 text-center text-gray-800">{{ studentName }}</h1>

  <!-- Buttons Row -->
  <div class="flex justify-between mb-4">
    <!-- Generate Result Button at the Top Left -->
    <button @click="generateResult" class="bg-green-500 text-white px-4 py-2 rounded">Generate Result</button>

    <!-- Detailed Report Button at the Top Right -->
    <button @click="goToDetailedReport" class="bg-blue-500 text-white px-4 py-2 rounded">Detailed Report</button>
  </div>

  <!-- Table-like Layout -->
  <div class="grid grid-cols-2 gap-4">
    <!-- Left Side: Concatenated Content -->
    <div class="flex flex-col border border-gray-300 rounded-lg p-4">
      <div v-html="formattedContent(studentPagesContent)" class="whitespace-pre-wrap"></div>
    </div>

    <!-- Right Side: Generated Result -->
    <div class="flex flex-col border border-gray-300 rounded-lg p-4">
      <div v-if="loading" class="text-center mb-4">
        <div class="loader"></div>
        <p class="text-gray-500 mt-2">Generating result, please wait...</p>
      </div>
      <div v-if="result">
        <div v-html="formattedContent(result)" class="whitespace-pre-wrap"></div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from '../services/axiosInstance'

export default {
  data () {
    return {
      studentName: '',
      studentPagesContent: '',
      loading: false,
      result: null
    }
  },
  async created () {
    const studentId = this.$route.params.studentId

    try {
      // Fetch student's name
      const studentResponse = await axios.get(`/students/${studentId}`)
      this.studentName = studentResponse.data.name

      // Fetch student's page content
      const pageContentResponse = await axios.get(`/students/${studentId}/pagecontents`)
      this.studentPagesContent = pageContentResponse.data

      // Fetch result if exists
      const studentResult = await axios.get(`/students/${studentId}/result`)
      this.result = studentResult.data
    } catch (error) {
      console.error('Error fetching student data:', error)
    }
  },
  methods: {
    async generateResult () {
      const studentId = this.$route.params.studentId
      this.loading = true

      try {
        const response = await axios.get(`/students/${studentId}/generate-result`)
        this.result = response.data
      } catch (error) {
        console.error('Error generating result:', error)
      } finally {
        this.loading = false
      }
    },
    goToDetailedReport () {
      const studentId = this.$route.params.studentId
      this.$router.push(`/students/${studentId}/detailed-report`)
    },
    formattedContent (content) {
      // This ensures that newlines are rendered in HTML
      return content.replace(/\n/g, '<br>')
    }
  }
}
</script>

<style scoped>
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

div {
  word-wrap: break-word;
  white-space: pre-wrap;
}
</style>
